import React, { useEffect, useState, useRef } from 'react';

/**
 * Horizontal reading ruler that follows the cursor's vertical position.
 * Helps users with focus / dyslexia track lines while reading.
 */
export const ReadingGuide = ({ enabled }) => {
  const [y, setY] = useState(-9999);
  const rafRef = useRef(null);
  const lastEventRef = useRef(null);

  useEffect(() => {
    if (!enabled) {
      setY(-9999);
      return;
    }
    const handleMove = (e) => {
      lastEventRef.current = e;
      if (rafRef.current) return;
      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = null;
        if (lastEventRef.current) setY(lastEventRef.current.clientY);
      });
    };
    window.addEventListener('mousemove', handleMove, { passive: true });
    return () => {
      window.removeEventListener('mousemove', handleMove);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [enabled]);

  if (!enabled) return null;

  const stripeHeight = 56;
  const top = y - stripeHeight / 2;

  return (
    <div
      data-a11y-widget="reading-guide"
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 2147483500,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: Math.max(0, top),
          background: 'rgba(0,0,0,0.45)',
          transition: 'height 60ms linear',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: top + stripeHeight,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.45)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top,
          left: 0,
          right: 0,
          height: stripeHeight,
          borderTop: '2px solid rgba(20, 184, 166, 0.9)',
          borderBottom: '2px solid rgba(20, 184, 166, 0.9)',
        }}
      />
    </div>
  );
};

export default ReadingGuide;
